import { PhoneNumberUtil } from 'google-libphonenumber';

export default {
    isPossibleNumber: (input, phoneCountry) => {
        let indexOfXInInput;
        let phoneNumber;
        const phoneNumberUtilInstance = PhoneNumberUtil.getInstance();
        let isPossibleNumber = true;
        if (input) {
            phoneNumber = (phoneNumber =
                (indexOfXInInput = input.indexOf(' x')) > 0 ? input.substring(0, indexOfXInInput) : input).replace(
                /[-_]/g,
                ''
            );
            try {
                isPossibleNumber = phoneNumberUtilInstance.isPossibleNumber(
                    phoneNumberUtilInstance.parse(phoneNumber, phoneCountry)
                );
            } catch (error) {
                return false;
            }
        }
        return isPossibleNumber;
    },
};
